import React, { Component } from "react";
import { Alert, Table, Button } from "antd";
import KeywordResearchSuggestions from "../../containers/KeywordResearch/KeywordResearchSuggestions";
import TableColumnWithTooltip from "../shared/TableColumnWithTooltip/TableColumnWithTooltip";
import { semTableColumns } from "../shared/TableColumnWithTooltip/semTableColumns";
import KeywordPosition from "../shared/KeywordPosition";
import IconLabel from "../shared/IconLabel/IconLabel";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";
import ModalTitle from "../shared/ModalTitle/ModalTitle";
import SparklineChart from "../shared/SparklineChart/SparklineChart";
import ExportAsFile from "../shared/ExportAsFile/ExportAsFile";

const { Column } = Table;

const showSuggestionsRender = record => (
  <KeywordResearchSuggestions
    openLabel="Show"
    modalTitle={<ModalTitle title="Keywords suggestions for: " meta={record.keyword} />}
    keyword={record.keyword}
  />
);

const urlRender = record => {
  if (record.url) {
    return (
      <a target="_blank" href={record.url} rel="noopener noreferrer">
        {record.url}
      </a>
    );
  }
  return "-";
};

class TopKeywordsReport extends Component {
  render() {
    const { isLoading, isFirstKeywordsFetch, keywords, hasMore, onLoadMore, showSuggestions } = this.props;
    const tableDataSource = keywords.map((keyword, idx) => ({
      key: idx + 1,
      keyword: keyword.phrase,
      suggestions: null,
      position: keyword["pos"] ? parseInt(keyword["pos"]) : null,
      previousPosition: keyword["prev_pos"] ? parseInt(keyword["prev_pos"]) : 0,
      traffic: keyword["traffic"] ? parseFloat(keyword["traffic"]).toLocaleString() : "-",
      difficulty: keyword["difficulty"] ? parseFloat(keyword["difficulty"]).toLocaleString() : "-",
      searchVolume: keyword["vol"] ? parseInt(keyword["vol"]).toLocaleString() : "-",
      cpc: keyword["cpc"] ? parseFloat(keyword["cpc"]).toLocaleString() : "-",
      resultsNo: keyword["r_no"] ? parseInt(keyword["r_no"]).toLocaleString() : "-",
      url: keyword.url,
      trends: keyword["trends"]
    }));

    if (isFirstKeywordsFetch) {
      return <LoadingIndicator />;
    }
    return keywords.length ? (
      <div className="keywords-table">
        <Table dataSource={tableDataSource} pagination={false} size="small">
          <Column title="#" dataIndex="key" align="left" width="43" className="no-wrap" />
          <Column className="no-wrap" title="Keyword" dataIndex="keyword" />
          {showSuggestions ? (
            <Column
              className="al-center no-wrap"
              title="Suggestions"
              dataIndex="suggestions"
              render={(_, record) => showSuggestionsRender(record)}
            />
          ) : null}
          <Column
            title={<TableColumnWithTooltip {...semTableColumns["position"]} />}
            dataIndex="position"
            render={(_, record) => <KeywordPosition {...record} />}
          />
          <Column
            className="al-right"
            title={<TableColumnWithTooltip {...semTableColumns["traffic"]} />}
            dataIndex="traffic"
          />

          <Column
            className="al-right"
            title={<TableColumnWithTooltip {...semTableColumns["difficulty"]} />}
            dataIndex="difficulty"
          />

          <Column
            className="al-right"
            title={<TableColumnWithTooltip {...semTableColumns["search_volume"]} />}
            dataIndex="searchVolume"
          />

          <Column
            className="truncate"
            title={<TableColumnWithTooltip {...semTableColumns["url"]} />}
            dataIndex="url"
            render={(_, record) => urlRender(record)}
          />

          <Column className="al-right" title={<TableColumnWithTooltip {...semTableColumns["cpc"]} />} dataIndex="cpc" />

          <Column
            className="al-right"
            title={<TableColumnWithTooltip {...semTableColumns["results_no"]} />}
            dataIndex="resultsNo"
          />

          <Column
            className="keyword-trends al-center"
            title={<TableColumnWithTooltip {...semTableColumns["trends"]} />}
            dataIndex="trends"
            render={(_, record) => {
              if (record["trends"]) {
                const trend = record["trends"].split(",").map(item => parseFloat(item));
                return <SparklineChart data={trend} />;
              }
              return "-";
            }}
          />
        </Table>

        {hasMore ? (
          <Button className="load-more" type="primary" loading={isLoading} onClick={onLoadMore}>
            Load more
          </Button>
        ) : null}

        <div className="export-buttons">
          <ExportAsFile fileContent={this.props.keywordsAsCsv} fileName="top_keywords.csv" fileMime="text/csv">
            <Button className="light-text">
              <IconLabel icon="download" label="Export CSV" />
            </Button>
          </ExportAsFile>

          <ExportAsFile
            fileContent={this.props.keywordsAsJson}
            fileName="top_keywords.json"
            fileMime="application/json">
            <Button className="light-text">
              <IconLabel icon="download" label="Export JSON" />
            </Button>
          </ExportAsFile>
        </div>
      </div>
    ) : (
      <Alert message="Your domain has no indexed keywords!" />
    );
  }
}

export default TopKeywordsReport;
